// MinMaxInput.tsx
import { MarginOutlined } from "@mui/icons-material";
import { TextField } from "@mui/material";

const textFieldInputProps = {
    style: {
        height: "1.2rem",
        flex: 1,
        padding: "4px 10px 2px 8px",
        width: "10.6rem",
        fontSize: "14px",        
    },
};

interface MinMaxInputProps {
    value: string | number;
    onChange: (value: string) => void;
    onBlur: () => void;
    disabled?: boolean;
}

export const MinMaxInput = ({ value, onChange, onBlur, disabled }: MinMaxInputProps) => {
    return (
        <TextField
            type="number"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ ...textFieldInputProps }}
            onBlur={onBlur}
            disabled={disabled}
            sx={{
                backgroundColor: "rgb(239,239,239,0.3)",
                borderRadius: "4px",
                marginLeft: "5px",
            }}
        />
    );
};